// extracted by css-extract-rspack-plugin
export default {"Label":"aggregate-labels-module__Label__WQX6O","default":"aggregate-labels-module__default__iK4VV","danger":"aggregate-labels-module__danger__EcQN_"};